import $ from 'jquery';


class EditQuotation {

	constructor() {
		if ($("#editQuotationModal").length> 0) {
			this.init();
		}
	}

	init() {

		Vue.component('create-quotation',  () => import('../components/CreateQuotation.vue'));

		const self = this;
		let vm = new Vue({
	        el: "#editQuotationModal",
	        data: window.quotation_data,
	        methods: {
	            save() {
	                self.save(this.input)
	            }
	        }
	    });

	    
	            
        $.ajax({
            data: {op: "getClientEntities", id: window.quotation_data.client_id},
            success: (entities) => {
                vm.input.billing = entities;
                vm.input.billing_id = entities.length > 0 ? entities[0].id : 0;
            }

        })

	       
	}

	save(data) {

		if (window.quotation_data.id) {

			let params = {
				id: window.quotation_data.id,
				billing: data.billing_id,
				item: data.invoicable_id,
				description: data.description,
				amount: data.amount,
				discount: data.discount,
				ponumber: data.ponumber,
				op: "updateQuotation"
			};

			$.ajax({
				data: params
			});

		} else {

			let params = {
				id: this.product_id,
				client: this.client_id,
				billing: data.billing_id,
				item: data.invoicable_id,
				description: data.description,
				amount: data.amount,
				discount: data.discount,
				ponumber: data.ponumber,
				op: "createQuotation"
			};

			$.ajax({
				data: params
			});
		}
	}

}

export default EditQuotation;
